import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";

import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { FeaturedArtist } from "@/components/FeaturedArtist";
import { TrustMarquee } from "@/components/TrustMarquee";
import { WhatIsMaajja } from "@/components/WhatIsMaajja";
import { MaajjaSound } from "@/components/MaajjaSound";
import { Features } from "@/components/Features";
import { HowItWorks } from "@/components/HowItWorks";
import { UpcomingArtists } from "@/components/UpcomingArtists";
import { YaallFestival } from "@/components/YaallFestival";
import { ArtistFirst } from "@/components/ArtistFirst";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { JoinModal } from "@/components/JoinModal";

function App() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.1,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        const id = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(id);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App relative">
            <Navbar />
            <main>
                <Hero />
                <FeaturedArtist />
                <MaajjaSound />
                <YaallFestival />
                <TrustMarquee />
                <WhatIsMaajja />
                <Features />
                <HowItWorks />
                <UpcomingArtists />
                <ArtistFirst />
                <FinalCTA />
            </main>
            <Footer />
            <JoinModal />
        </div>
    );
}

export default App;
